function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256 0C114.637 0 0 114.637 0 256C0 397.363 114.637 512 256 512C397.363 512 512 397.363 512 256C512 114.637 397.363 0 256 0ZM181.609 387H119.262V199.426H181.609V387ZM150.438 173.812H150.031C129.109 173.812 115.578 159.41 115.578 141.41C115.578 123.004 129.523 109 150.852 109C172.18 109 185.305 123.004 185.711 141.41C185.711 159.41 172.18 173.812 150.438 173.812ZM406.422 387H344.082V286.652C344.082 261.434 335.055 244.234 312.496 244.234C295.273 244.234 285.016 255.836 280.508 267.035C278.859 271.043 278.457 276.645 278.457 282.25V387H216.113C216.113 387 216.93 217.023 216.113 199.426H278.457V225.984C286.742 213.203 301.566 195.023 334.645 195.023C375.664 195.023 406.422 221.832 406.422 279.445V387Z",
  fill: "white"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.0965a8ff.svg";
export { ForwardRef as ReactComponent };